// ----------------------------------------------------------------------
// <copyright file="Izenda.EdgeDetector.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var Utils = require('share/utils/Izenda.DomUtils');
  var domHelperEvents = require('dom-helpers/events');
  var observer = require('mobx-react').observer;
  const { throttle } = require('lodash/fp');
  var EdgeDetector = React.createClass({
    propTypes: {
      onChanged: PropTypes.func
    },
    getDefaultProps: function() {
      return {
        onChanged: null
      };
    },
    componentDidMount: function() {
      var throttleScroll = throttle(250, this.handleScroll);

      this.scrollableAncestor = Utils.findScrollableParent(this.boundary);
      this.scrollableAncestor && domHelperEvents.on(this.scrollableAncestor, 'scroll', throttleScroll);

      this.unlisten = () => {
        this.scrollableAncestor && domHelperEvents.off(this.scrollableAncestor, 'scroll', throttleScroll);
      };

      this.handleScroll(null);
    },
    componentDidUpdate: function() {
      this.handleScroll(null);
    },
    componentWillUnmount() {
      this.unlisten();
    },
    render: function() {
      return (
        <div ref={this.refBoundary} className={this.props.className}>
          {this.props.children}
        </div>
      );
    },
    refBoundary: function(node) {
      this.boundary = node;
    },
    handleScroll: function(event) {
      try {
        var bounds = this.getBounds();
        var isOnEdge = this.isOnEdge(bounds);

        var previousState = this.previousState;

        if (previousState === isOnEdge) {
          return;
        }
        this.previousState = isOnEdge;
        this.props.onChanged && this.props.onChanged(isOnEdge);
      } catch (e) {
        // do nothing
      }
    },
    getBounds: function() {
      var boundaryRect = this.boundary.getBoundingClientRect();
      var scrollTop = this.scrollableAncestor.getBoundingClientRect().top;
      var scrollHeight = this.scrollableAncestor.clientHeight;

      return {
        top: boundaryRect.top,
        bottom: boundaryRect.bottom,
        viewportTop: scrollTop,
        viewportBottom: scrollTop + scrollHeight
      };
    },
    isOnEdge: function(bounds) {
      if (bounds.viewportBottom - bounds.viewportTop === 0) {
        return false;
      }
      return bounds.viewportTop >= bounds.top && bounds.viewportTop <= bounds.bottom;
    }
  });

  module.exports = observer(EdgeDetector);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.EdgeDetector.jsx